import { Navigate, Route, Routes } from 'react-router-dom';
import loadable from '@loadable/component';
import LoginPage from './components/auth/LoginPage';
import ForgotPassword from 'components/auth/ForgotPassword';
import ResetPassword from 'components/auth/ResetPassword';
import PrivateRoute from 'components/routes/PrivateRoute';
import EdfViewer from 'components/edfViewer/EdfViewer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/styles/app.scss';
import 'assets/styles/customtheme.scss';
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import 'assets/styles/resolution.scss';
import ChangePassword from 'components/auth/ChangePassword';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import Mfa from 'components/auth/Mfa';
import CustomerAgreement from 'components/auth/CustomerAgreement';
import SignupAccount from 'components/auth/SignupAccount';
import { useEffect } from 'react';
import TestSpring from 'components/account/sub-screens/TestSpring';
import SessionTimeout from 'components/SessionTimeout';
import LandingPage from 'components/LandingPage';
import PaymentInformationScreen from 'components/auth/PaymentInformationScreen';
import PatientAgreement from 'components/auth/PatientAgreement';
import ResourceViewer from 'components/auth/ResourceViewer';
import ConsentSuccess from 'components/auth/sub-screens/ConsentSuccess';
import LinkExpired from 'components/auth/sub-screens/LinkExpired';
const EmailSentForm = loadable(() => import('components/auth/EmailSentForm'), { fallback: <LoadingIndicator /> });
const Page404 = loadable(() => import('components/auth/Page404'), { fallback: <LoadingIndicator /> });
const PatientIntakeForm = loadable(() => import('components/PatientIntakeForm'), { fallback: <LoadingIndicator /> });
import 'react-international-phone/style.css';

function App() {
    const isAuth = sessionStorage.getItem('token') === "true";
    const hasUserInfo = Number(sessionStorage.getItem('accountid'));
    const shouldShowAgreement = sessionStorage.getItem('agreement') === "true";
    const showPassReset = sessionStorage.getItem('passresetflag') === "true";
    const showMfa = sessionStorage.getItem('mfa_enabled') === "true";

    const handleLogout = () => {
        // Clear session/token and redirect to login
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
    };
    // Define paths where SessionTimeout should NOT be shown
    const excludeTimeoutPaths = [
        '/login',
        '/reset-password',
        '/email-sent',
        '/change-password',
        '/change-default-password',
        '/user-verification',
        '/signup-account',
        '/customer-agreement',
        '/patient-form',
        '/page404',
        '/edf',
        '/user-verification',
        '/test',
        '/customer-agreementd',
        '/home',
        '/payment-information',
        '/patient-consent-form',
        '/template-manager',
        '/add-template-manager',
        '/consent-success',
        '/link-expired',
        '/resource-viewer'
    ];

    // Check if current path should exclude SessionTimeout
    const shouldShowTimeout = !excludeTimeoutPaths.some(path => location.pathname.startsWith(path));
    useEffect(() => {
        const handleRightClick = (e) => {
            e.preventDefault(); // Prevent right-click
        };
        // const handleKeyDown = (e) => {
        //     // F12
        //     if (e.key === "F12") {
        //         e.preventDefault();
        //         return;
        //     }

        //     // Ctrl + Shift + I / C / J
        //     if (
        //         e.ctrlKey &&
        //         e.shiftKey &&
        //         ["I", "C", "J"].includes(e.key)
        //     ) {
        //         e.preventDefault();
        //     }

        //     // Ctrl + U
        //     if (e.ctrlKey && e.key === "u") {
        //         e.preventDefault();
        //     }
        // };

        document.addEventListener("contextmenu", handleRightClick);
        // document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("contextmenu", handleRightClick); // Cleanup on component unmount
            // document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return (
        <div className="App">
            {shouldShowTimeout ? (<SessionTimeout onLogout={handleLogout} warningDuration={5 * 60 * 1000} timeout={30 * 60 * 1000} />) : ""}
            <Routes>
                <Route path="/login" element={<LoginPage />}></Route>
                <Route path='/home' element={<LandingPage />} />
                <Route path="/reset-password" element={<ForgotPassword />}></Route>
                <Route path="/email-sent" element={<EmailSentForm />}></Route>
                <Route path="/change-password/:id" element={<ChangePassword />} />
                <Route path="/page404" element={<Page404 />}></Route>
                <Route path="/patient-form/:id" element={<PatientIntakeForm />}></Route>
                <Route path="/change-default-password" element={<ResetPassword />}></Route>
                <Route path='/payment-information' element={<PaymentInformationScreen />}></Route>
                <Route path="/patient-consent-form/:id" element={<PatientAgreement />}></Route>
                <Route path="/resource-viewer/:id" element={<ResourceViewer />}></Route>
                {/* <Route path="/" element={<Navigate replace to="/login" />} /> */}
                <Route path="/edf" element={<EdfViewer />}></Route>
                <Route path="/user-verification" element={<Mfa />}></Route>
                <Route path="/customer-agreement/:id" element={<CustomerAgreement />}></Route>
                <Route path='/signup-account' element={<SignupAccount />} />
                <Route path="/customer-agreementd" element={<CustomerAgreement />}></Route>
                <Route path='/consent-success' element={<ConsentSuccess />} />
                
                {/* Redirect to login by default */}
                <Route path="/" element={<Navigate replace to="/home" />} />
                <Route path='/test' element={<TestSpring />}></Route>
                <Route path='/link-expired' element={<LinkExpired/>}/>

                {/* Use conditional routes for protected pages */}
                {isAuth || (hasUserInfo) ? (
                    // !shouldShowAgreement && shouldShowAgreement !== null && hasUserInfo!=0 ? (
                    //     <Route path="*" element={<CustomerAgreement />} />
                    // ) :
                    showPassReset && showPassReset !== null && hasUserInfo != 0 ? (
                        <Route path="*" element={<ResetPassword />} />
                    ) : showMfa && showMfa !== null ? (
                        <Route path="*" element={<Mfa />} />
                    ) : (
                        <Route path="*" element={<PrivateRoute />} />
                    )
                ) : (
                    <Route path="*" element={<Navigate to="/login" />} />
                )}
            </Routes>
        </div>
    );
}

export default App;
